import React from 'react';

export default function Spinner() {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner"> <i className="fas fa-car-side fa-2x" /> </div>
    </div>
  );
}
